import { defineModule } from "direct-vuex";
import { moduleActionContext, moduleGetterContext } from "@/store";
import administrationUsers from "@/store/modules/administration/administrationUsers";
import administrationRoles from "@/store/modules/administration/administrationRoles";
import administrationOffices from "@/store/modules/administration/administrationOffices";
import administrationAttributes from "@/store/modules/administration/administrationAttributes";
import administrationContractors from "@/store/modules/administration/contractor/administrationContractors";
import administrationServiceTypes from "@/store/modules/administration/administrationServiceTypes";
import administrationServiceGroups from "@/store/modules/administration/administrationServiceGroups";
import administrationServicePackages from "@/store/modules/administration/administrationServicePackages";
import administrationServiceAttributes from "@/store/modules/administration/administrationAttributeTemplates";
import taskSchedulerTask from "@/store/modules/administration/administrationTaskScheduler";
import administrationBookingService from "@/store/modules/administration/administrationBookingService";
import administrationBookingFiles from "@/store/modules/administration/administrationBookingFiles";
import administrationBankAccounts from "@/store/modules/administration/administrationBankAccount";
import administrationBankAccountsAssign from "@/store/modules/administration/administrationBankAccountAssign";
import administrationExchangeRate from "@/store/modules/administration/administrationExchangeRate";
import administrationPrinters from "@/store/modules/administration/administrationPrinters";
import administrationMailBoxConfiguration from "@/store/modules/administration/administrationMailBoxConfiguration";
import administrationIntegration from "@/store/modules/administration/administrationIntegration";
import administrationWorkFlow from "@/store/modules/administration/administrationWorkFlow";
import administrationExportConfiguration from "@/store/modules/administration/administrationExportConfiguration";
import administrationMailBoxContent from "@/store/modules/administration/administrationMailBoxContent";
import administrationMailBoxHistory from "@/store/modules/administration/administrationMailBoxHistory";
import administrationMailBoxBookingFiles from "@/store/modules/administration/administrationMailBoxBookingFiles";
import AdministrationPaymentMethods from "@/store/modules/administration/administrationPaymentMethods";
import administrationAirlines from "@/store/modules/administration/administrationAirlines";
import AdministrationCreditCardsModule from "@/store/modules/administration/administrationCreditCards";
import AdministrationUserCreditCardsModule from "@/store/modules/administration/administrationUserCreditCards";
import AdministrationGDSModule from "@/store/modules/administration/administrationGDS";
import AdministrationCostHints from "@/store/modules/administration/administrationCostHints";
import AdministrationKsefCertModule from "@/store/modules/administration/administrationKsefCert";
import AdministrationKsefOnyxFixModule from "@/store/modules/administration/administrationOnyxFix";

const AdministrationModule = defineModule({
  modules: {
    users: administrationUsers,
    roles: administrationRoles,
    offices: administrationOffices,
    attributes: administrationAttributes,
    contractors: administrationContractors,
    serviceTypes: administrationServiceTypes,
    serviceGroups: administrationServiceGroups,
    servicePackages: administrationServicePackages,
    attributeTemplates: administrationServiceAttributes,
    taskScheduler: taskSchedulerTask,
    bookingService: administrationBookingService,
    bookingFiles: administrationBookingFiles,
    bankAccounts: administrationBankAccounts,
    bankAccountsAssign: administrationBankAccountsAssign,
    exchangeRate: administrationExchangeRate,
    printers: administrationPrinters,
    mailBoxConfiguration: administrationMailBoxConfiguration,
    mailBoxContent: administrationMailBoxContent,
    mailBoxHistory: administrationMailBoxHistory,
    mailBoxBookingFiles: administrationMailBoxBookingFiles,
    integration: administrationIntegration,
    workflow: administrationWorkFlow,
    exportConfiguration: administrationExportConfiguration,
    paymentMethods: AdministrationPaymentMethods,
    airlines: administrationAirlines,
    creditCards: AdministrationCreditCardsModule,
    userCreditCards: AdministrationUserCreditCardsModule,
    gds: AdministrationGDSModule,
    costHints: AdministrationCostHints,
    ksefCert: AdministrationKsefCertModule,
    onyxFix: AdministrationKsefOnyxFixModule,
  },
  namespaced: true as const,
});

export default AdministrationModule;

/* eslint-disable */
// noinspection JSUnusedLocalSymbols
const _moduleGetterContext = (args: [any, any, any, any]) =>
  moduleGetterContext(args, AdministrationModule);
const _moduleActionContext = (context: any) =>
  moduleActionContext(context, AdministrationModule);
